import { orgAddressFragment, transportOrderFragment } from 'apollo/fragments';
import {
    detailedNShiftShipmentWaybillFragment,
    nShiftPartnerServiceFragment,
    nShiftShipmentWaybillFragment,
    transportOrderAdminFragment,
} from 'apollo/fragments/transport';
import { gql } from 'graphql.macro';

export const transportLinesTemplate = gql`
    query transportLines($date: Date!) {
        transportLines(date: $date) {
            _id
            lab {
                _id
                name
            }
            name
            transportDate
            clinic {
                _id
                name
            }
            transportProviderName
            transportOrders {
                ...transportOrderFields
            }
            waybills {
                ...detailedNShiftShipmentWaybillFields
            }
            fee {
                name
                value
            }
            isDeleted
        }
    }
    ${transportOrderFragment}
    ${detailedNShiftShipmentWaybillFragment}
`;

export const transportLinesForOrderTemplate = gql`
    query transportLinesForOrder($orderId: String!) {
        transportLinesForOrder(orderId: $orderId) {
            _id
            transportDate
            transportOrders {
                ...transportOrderFields
            }
            waybills {
                ...detailedNShiftShipmentWaybillFields
            }
        }
    }
    ${transportOrderFragment}
    ${detailedNShiftShipmentWaybillFragment}
`;

export const transportOpterLogTemplate = gql`
    query transportOpterLog($opterOrderId: Int!) {
        transportOpterLog(opterOrderId: $opterOrderId) {
            DateAndTime
            Status
            POD_Descr
            DEA_FileName
            DEA_Guid
            DateTimeString
            OFF_Id
            hasImage
        }
    }
`;

export const transportClinicsTemplate = gql`
    query transportClinics($labId: ID) {
        transportClinics(labId: $labId) {
            _id
            name
            contact {
                address {
                    street
                    city
                    postalCode
                }
            }
        }
    }
`;

export const getNShiftClinicsTemplate = gql`
    query nShiftClinics {
        nShiftClinics {
            _id
            name
            contact {
                address {
                    ...orgAddressFields
                }
            }
        }
    }
    ${orgAddressFragment}
`;

export const transportsTemplate = gql`
    query transports($filters: TransportOrderFilter, $limit: Int, $offset: Int) {
        transports(filters: $filters, limit: $limit, offset: $offset) {
            ...transportOrderAdminFields
        }
    }
    ${transportOrderAdminFragment}
`;

export const clinicDeliveryOrdersTemplate = gql`
    query clinicDeliveryOrders {
        clinicDeliveryOrders {
            _id
            transportProvider {
                channel
                externalId
                code
            }
            clinic {
                _id
                name
                contact {
                    address {
                        street
                        postalCode
                        city
                    }
                }
            }
            orders {
                _id
                orderId
                dentist {
                    name {
                        firstName
                        lastName
                    }
                    fullName
                }
                patient {
                    firstName
                    lastName
                    personalIdentityNumber
                }
                deliveryDetails {
                    date
                }
            }
        }
    }
`;

export const waybillsTemplate = gql`
    query waybills($filters: WaybillsFilter, $limit: Int, $offset: Int) {
        waybills(filters: $filters, limit: $limit, offset: $offset) {
            ...nShiftShipmentWaybillFields
        }
    }
    ${nShiftShipmentWaybillFragment}
`;

export const waybillCountTemplate = gql`
    query waybillCount {
        waybillCount
    }
`;

export const nShiftPartnerTemplate = gql`
    query nShiftPartner($partnerId: String!) {
        nShiftPartner(partnerId: $partnerId) {
            id
            description
            services {
                ...nShiftPartnerServiceFields
            }
        }
    }
    ${nShiftPartnerServiceFragment}
`;
